import { useFormContext, Controller } from 'react-hook-form';
import { CrossInCircleIcon, TickInCircleIcon } from '../Icons';
import { TextField } from '../TextField';
import { IFormTextFieldProps } from './types';

export const FormTextField: React.FC<IFormTextFieldProps> = ({
  defaultValue = '',
  name,
  rules,
  disabled = false,
  type = 'text',
  textFieldProps,
  staticFormHelperText,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      defaultValue={defaultValue}
      rules={rules}
      name={name}
      control={control}
      render={props => {
        const isInteracted = props.fieldState.isDirty || props.fieldState.isTouched;
        const isError = Boolean(props.fieldState.error);
        const endAdornment = isInteracted ? (
          isError ? (
            <CrossInCircleIcon className='cursor-pointer' onClick={() => props.field.onChange('')} />
          ) : (
            <TickInCircleIcon />
          )
        ) : null;

        return (
          <TextField
            type={type}
            disabled={disabled}
            InputLabelProps={{ shrink: true }}
            value={props.field.value === undefined ? '' : props.field.value}
            fullWidth
            error={isError}
            helperText={props.fieldState.error?.message || staticFormHelperText || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const newValue = textFieldProps?.type === 'number' ? Number(event.target.value) : event.target.value;

              props.field.onChange(newValue);
            }}
            inputRef={props.field.ref}
            {...{
              ...textFieldProps,
              InputProps: {
                ...textFieldProps?.InputProps,
                endAdornment: endAdornment,
              },
            }}
          />
        );
      }}
    />
  );
};
